// extracted by mini-css-extract-plugin
module.exports = {"jobCardA-body":"jobCardA-body","jobCardA-body__right":"jobCardA-body__right"};